import { Component, Vue, Watch } from 'vue-property-decorator';
import { WatchOptions } from 'vue';
import { LocaleMessage } from 'vue-i18n';
import { GetterTypes } from '@/store-vuex/types';

@Component
export default class MoreInfo extends Vue {
  protected shortContactInfo: LocaleMessage = '';
  get isLanguagesLoaded() { return this.$store.getters[GetterTypes.isLanguagesLoaded]; }

  public get isFaqLinkSet(): boolean {
    const faqUrl = this.$te('comp.moreInfo.faqUrl') && String(this.$t('comp.moreInfo.faqUrl')).trim();
    const faqLinkText = this.$te('comp.moreInfo.faqLinkText') && String(this.$t('comp.moreInfo.faqLinkText')).trim();
    return Boolean(faqUrl && faqLinkText);
  }

  @Watch('isLanguagesLoaded', { immediate: true, deep: true } as WatchOptions)
  protected onIsLanguagesLoadedChanged({ to, from }: { to: boolean; from: boolean; }) {
    if (this.isLanguagesLoaded === true) {
      this.shortContactInfo = this.$t('comp.contact.shortContactInfo');
    }
  }

  @Watch('$i18n.locale', { immediate: true, deep: true } as WatchOptions)
  protected onLocaleChanged({ to, from }: { to: boolean; from: boolean; }) {
    if (this.isLanguagesLoaded === true) {
      this.shortContactInfo = this.$t('comp.contact.shortContactInfo');
    }
  }
}
